/**
 * Rich Matching Content Type
 * A content type with lesson content (Page) and matching questions
 */

// Package version
import pkgJson from '../package.json';
export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

// Schema and types
export {
    richMatchingSchema,
    defaultRichMatchingConfig,
    defaultRichMatchingData,
    defaultRichMatchingI18n,
    type RichMatchingContent,
    type RichMatchingData,
    type RichMatchingConfig,
    type RichMatchingLayoutConfig,
    type RichMatchingScoringConfig,
    type PlayerViewLayout,
} from './schema';

// Components
export { RichMatchingEdit, type RichMatchingEditProps } from './RichMatchingEdit';
export { RichMatchingPlayer, type RichMatchingPlayerProps } from './RichMatchingPlayer';

// Default export
export { richMatchingSchema as default } from './schema';

export { richMatchingValidator } from './validator';

export { countRichMatchingQuestions, richMatchingQuestionCounter } from './questionCount';
